<template>
  <div class="">
    <la-vr v-show="visiable" :filename="filename" @close="handleClose"/>
    <div class="map-wrap">
      <div class="mini-map">
        <div v-for="l in links" :key="l.text" class="btn" :style="{ top: l.top, left: l.left }" @click="handleClick(l.name)">{{ l.text }}</div>
      </div>
      <div v-if="current" class="btn current" :style="{ top: current.top, left: current.left }">{{ current.text }}</div>
    </div>
  </div>
</template>

<script>
import LaVr from './LaVr'
export default {
  name: 'MiniMap',
  components: {
    LaVr,
  },
  data () {
    return {
      filename: '',
      visiable: false,
      narrPlaying: false,
      links: [
        { top: '0.87rem', left: '0.58rem', name: 'Experience', text: '大桥漫游' },
        { top: '1.45rem', left: '1.04rem', name: '1', text: '九洲桥' },
        { top: '0.37rem', left: '1.535rem', name: '2', text: '江海桥' },
        { top: '0.91rem', left: '2.295rem', name: '4', text: '青州桥' },
        { top: '0.06rem', left: '2.69rem', name: '5', text: '西人工岛' },
        { top: '0.91rem', left: '3.08rem', name: '6', text: '海底隧道' },
        { top: '0.05rem', left: '3.54rem', name: '7', text: '东人工岛' },
      ],
    }
  },
  computed: {
    current () {
      return this.links.find(l => l.to === this.$route.path)
    },
  },
  methods: {
    handleClick (filename) {
      const narrate = this.$narrate.getInstance()
      if (narrate && !narrate.audio.paused) {
        this.narrPlaying = true
        this.$narrate.pause()
      }

      this.filename = filename
      this.visiable = true
    },
    handleClose () {
      const narrate = this.$narrate.getInstance()
      if (this.narrPlaying) {
        narrate.audio.play()
      }
      this.narrPlaying = false
      this.filename = ''
      this.visiable = false
    },
  },
}
</script>

<style lang="scss" scoped>
.map-wrap {
  position: absolute;
  right: 0.1rem;
  bottom: 0.1rem;
  width: 5rem;
  height: 2.06rem;
}
.mini-map {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(../assets/img/icon/mini_map.png);
  background-size: 100% 100%;
  transition: opacity .5s;
  opacity: 0.2;
  &:hover {
    opacity: 1;
    z-index: 100;
    .btn {
      opacity: 0;
    }
  }
}
.btn {
  position: absolute;
  padding: 0.04rem 0.1rem;
  border-radius: 0.04rem;
  font-size: 0.15rem;
  text-decoration: none;
  color: rgba(0, 0, 0, 0);
  cursor: pointer;
  &.current {
    border: 1px solid;
    background-color: #F7592E;
    color: #fff;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(255,255,255,.3);
  }
}
</style>
